export default "__VITE_ASSET__35459950__"